import React, { Component } from "react";
import { activeStepDataSelector } from "../selectors";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {nextStep} from '../actions';
import "./styles.scss";

class ErrorStep extends Component {
  handleContinue = () => {
    const { nextStep } = this.props;
    nextStep({ step: "form2" });
  };

  render() {
    const { activeStepData } = this.props;
    const { title, message, buttonText} = activeStepData || {};

    return (
      <div className="step-message">
        <h3 className="text-center">{title || ''}</h3>
        <p className="text-center">{message || ''}</p>
        {buttonText && (
          <div className="button-wrapper">
            <BlueBtn onClick={this.handleContinue}>
              {buttonText}
            </BlueBtn>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  activeStepData: activeStepDataSelector(),
});

const mapDispatchToProps = (dispatch) => ({
  nextStep: value => dispatch(nextStep(value))
});


ErrorStep = connect(mapStateToProps, mapDispatchToProps)(ErrorStep);
export default ErrorStep;
